export const SidebarWidths = {
    GroupContentAreaWidth: 64,
    GroupContentAreaHeight: 56,
    LinkContentAreaWidth: 240,
    LinkContentAreaWidthSmall: 184,
};

// TODO: Move this to the new theme when the time is right
export const NavigationGroupDetailBackgroundColor = '#faf9fa';

export const SIDEBAR_Z_INDEX = 30;
